import React from 'react'

function Footer() {
  return (
    <div className='max-w-[1640px] mx-auto p-4 flex text-center justify-center '>
        <p>Copyright&copy;2023 Best <span className='text-orange-500 font-bold text-xl'>Food</span></p>
    </div>
  )
}

export default Footer